export const sortFilterSettingItems = (
  filterSettings,
  filterFieldName,
  sortFunc
) => {
  if (filterSettings) {
    filterSettings = filterSettings.map((setting) => {
      if (setting.field === filterFieldName) {
        setting.items.sort(sortFunc);
      }
      return setting;
    });
  }
  return filterSettings;
};
